<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>

    <Header />
    <b-container fluid="">
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span>PORTAL DE DEALERS</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>DX_</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos">
          <p>Activacion de agentes y promotores</p>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <br />
          <h3>Búsqueda de caracteres</h3>
          <br />
        </b-col>
      </b-row>

      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form v-on:submit.prevent="handleSubmit(enviarDatos)">
          <b-row>
            <b-col cols="2">
              <b-form-group align="left">
                <label for="empresa">Tipo</label>
                <validation-provider
                  name="validacionidPerfil"
                  :rules="{ required: true }"
                  v-slot="errors"
                >
                  <v-select
                    label="descripcion"
                    v-model="idPerfil"
                    :reduce="(tipo) => tipo.idPerfil"
                    :options="arrayPerfil"
                    :state="
                      errors.errors[0] ? false : errors.valid ? true : null
                    "
                  >
                    <span slot="no-options">No hay datos...</span>
                  </v-select>
                  <validacion
                    :texto="errors.errors[0] ? errors.errors[0] : ' '"
                  ></validacion>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="4">
              <label for="archivo">Archivo</label>
              <validation-provider
                name="validacionArchivo"
                :rules="{ required: true }"
                v-slot="errors"
              >
                <b-form-file
                  v-model="archivo"
                  placeholder="Seleccionar archivo"
                  browse-text="Abrir"
                  type="file"
                  @change="cargarArchivo($event)"
                  :state="errors.errors[0] ? false : errors.valid ? true : null"
                ></b-form-file>
                <validacion
                  :texto="errors.errors[0] ? errors.errors[0] : ' '"
                ></validacion>
              </validation-provider>
              <br />
              <br />
              <b-button type="submit" class="btn-block" variant="success">
                <i class="fa fa-share" aria-hidden="true"></i> Enviar</b-button
              >
            </b-col>
            <b-col cols="6">
              <label for="archivo">Información</label>
              <b-list-group>
                <b-list-group-item
                  class="d-flex justify-content-between align-items-center"
                >
                  Nombre Archivo
                  <b-badge variant="primary" pill>{{
                    arrayDatosGeneralesExcel.nombreArchivo
                  }}</b-badge>
                </b-list-group-item>

                <b-list-group-item
                  class="d-flex justify-content-between align-items-center"
                >
                  Nombre Pestaña
                  <b-badge variant="primary" pill>{{
                    arrayDatosGeneralesExcel.nombrePestana
                  }}</b-badge>
                </b-list-group-item>

                <b-list-group-item
                  class="d-flex justify-content-between align-items-center"
                >
                  Cantidad Registros
                  <b-badge variant="primary" pill>{{
                    arrayDatosGeneralesExcel.cantidadRegistros
                  }}</b-badge>
                </b-list-group-item>
              </b-list-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>

      <b-row>
        <b-col cols="12" align="left">
          <br />
          El archivo de carga debe tener los siguientes datos en el orden
          establecido (La columna correspondiente esta entre parentesis):
          <a href="/files/Formato-actualizar-agentes-promotores.xlsx" download>
            Descargar Formato</a
          >

          <br />
          <ul>
            <br />
            <li>(A) aseguradora<span style="color:red;">*</span></li>
            <li>(B) id <strong>(clave agente o promotor key)</strong><span style="color:red;">*</span></li>
            <li>(C) nombre</li>
            <li>(D) correo</li>
            <li>(F) telefono</li>
            <li>(G) actualizar_nombre<strong>(si, no)</strong><strong>(No aplica para promotor)</strong></li>
            <li>(H) actualizar_correo(si, no)</li>
            <li>(I) actualizar_telefono<strong>(si, no)</strong> <strong>(El número de teléfono debe contar con 10 dígitos)</strong></li>
          </ul>

          <br />

          <p><span style="color:red;">*</span> Datos requeridos.</p>
          <p>
            En el campo aseguradora acepta los valores: (AXA, GNP, PLAN SEGURO,
            MAPFRE).
          </p>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12"><hr /></b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <br />
          <h3>Datos Procesados</h3>
          <br />

          <b-table 
            hover
            id="Pendientes"
            thead-tr-class="columnas"
            :items="datosRespuesta"
            :fields="layoutTabla"
            responsive
          >
            <template v-slot:cell(existeId)="row">
              <b-alert v-if="row.item.existeId" show variant="primary"
                >ENCONTRADO</b-alert
              >
              <b-alert v-else show variant="secondary">NO SE ENCONTRO</b-alert>
            </template>

            <template v-slot:cell(actualizoNombre)="row">
              <b-alert v-if="row.item.actualizoNombre" show variant="primary"
                >ACTUALIZADO</b-alert
              >
              <b-alert v-else show variant="secondary">NO ACTUALIZADO</b-alert>
            </template>

            <template v-slot:cell(actualizoCorreo)="row">
              <b-alert v-if="row.item.actualizoCorreo" show variant="primary"
                >ACTUALIZADO</b-alert
              >
              <b-alert v-else show variant="secondary">NO ACTUALIZADO</b-alert>
            </template>

            <template v-slot:cell(actualizoTelefono)="row">
              <b-alert v-if="row.item.actualizoTelefono" show variant="primary"
                >ACTUALIZADO</b-alert
              >
              <b-alert v-else show variant="secondary">NO ACTUALIZADO</b-alert>
            </template>

            <template v-slot:cell(activoUsuarioPortal)="row">
              <b-alert
                v-if="row.item.activoUsuarioPortal"
                show
                variant="primary"
                >ACTUALIZADO</b-alert
              >
              <b-alert v-else show variant="secondary">NO ACTUALIZADO</b-alert>
            </template>
          </b-table>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12"><hr /></b-col>
      </b-row>

      <b-row>
        <b-col cols="12"> </b-col>
      </b-row>

      <b-row>
        <b-col cols="12"> <br /><br /> </b-col>
      </b-row>

      <!-- </b-col>
      </b-row> -->
      <b-row>
        <b-col cols="12"> <br /><br /> </b-col>
      </b-row>
      <b-row>
        <b-col cols="12"> </b-col>
      </b-row>

      <!-- -------------------------- -->

      <b-row>
        <b-col> <br /><br /><br /><br /><br /><br /> </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import XLSX from "xlsx";

export default {
  name: "AgentesPromotores",
  components: {
    Header,
  },
  props: {},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    loading: false,
    idEmpleado: null,
    idUsuario: null,
    archivo: null,
    idPerfil: null,
    arrayPerfil: [
      {
        idPerfil: 1,
        descripcion: "Agente",
      },
      {
        idPerfil: 2,
        descripcion: "Promotor",
      },
    ],
    arrayDatosGeneralesExcel: {
      nombreArchivo: null,
      nombrePestana: null,
      cantidadRegistros: null,
    },

    arrayAgentesPromotores: [],

    datosRespuesta: [],
    layoutTabla: [
      {
        key: "aseguradora",
        label: "Aseguradora",
        sortable: true,
      },
      {
        key: "id",
        label: "Clave",
        sortable: true,
      },
      {
        key: "nombre",
        label: "Nombre",
        sortable: true,
      },
      {
        key: "correo",
        label: "Correo",
        sortable: true,
      },
      {
        key: "telefono",
        label: "Telefono",
        sortable: true,
      },
      {
        key: "existeId",
        label: "Se encontro el agente/promotor",
        sortable: true,
      },
      {
        key: "actualizoNombre",
        label: "Actualización del nombre",
        sortable: true,
      },
      {
        key: "actualizoCorreo",
        label: "Actualización del correo",
        sortable: true,
      },
      {
        key: "actualizoTelefono",
        label: "Actualización del telefono",
        sortable: true,
      }
    ],
  }),

  mounted() {},
  methods: {
    cargarArchivo(e) {
      this.loading = true;
      this.arrayAgentesPromotores = [];
      this.resultado = [];
      this.pacientes = [];
      const files = e.target.files;
      const fileReader = new FileReader(); // construction function that can read the file content
      fileReader.onload = (ev) => {
        const data = ev.target.result;
        const workbook = XLSX.read(data, {
          type: "binary", // binary
        });

        const nombrePestana = workbook.SheetNames[0]; //take the first sheet
        const ws = XLSX.utils.sheet_to_json(workbook.Sheets[nombrePestana]); //Get the data in this table
        this.arrayDatosGeneralesExcel.nombrePestana = nombrePestana;
        let lista = [];
        this.arrayDatosGeneralesExcel.cantidadRegistros = ws.length;

        lista = ws;

        lista.map((value) => {
          if (
            workbook.Strings[0].h == "aseguradora" &&
            workbook.Strings[1].h == "id" &&
            workbook.Strings[2].h == "nombre" &&
            workbook.Strings[3].h == "correo" &&
            workbook.Strings[4].h == "telefono" &&
            workbook.Strings[5].h == "actualizar_nombre" &&
            workbook.Strings[6].h == "actualizar_correo" &&
            workbook.Strings[7].h == "actualizar_telefono"
          ) {
            console.info("");
          } else {
            this.$swal.fire({
              icon: "info",
              title: "Aviso",
              text: "El formato no cumple con los campos básicos en uno registro.",
            });
            this.archivo = null;
            return false;
          }

          const agentesPromotores = {
            aseguradora: value["aseguradora"],
            id: value["id"],
            nombre: value["nombre"],
            correo: value["correo"],
            telefono: value["telefono"],
            actualizarNombre: value["actualizar_nombre"],
            actualizarCorreo: value["actualizar_correo"],
            actualizarTelefono: value["actualizar_telefono"],
          };

          this.arrayAgentesPromotores.push(agentesPromotores);
        });
        this.loading = false;
      };
      fileReader.readAsBinaryString(files[0]);
    },

    enviarDatos() {
      this.loading = true;
      this.datosRespuesta = [];
      this.arrayAgentesPromotores[0]["idPerfil"] = this.idPerfil;
      this.$http
        .post(
          this.$api +
            "etl/dealers/agentespromotores/activacionusuarios",
           this.arrayAgentesPromotores
        )
        .then((response) => {
          //NO devuelve un array asi que no funciona validar isArray
          if (response.data.data) {
            let resultado = response.data.data;
            this.datosRespuesta = resultado;
            this.$swal({
              icon: "success",
              text: "Exito al procesar los registros",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });

            this.limpiar();
          } else {
            this.$swal({
              icon: "error",
              text: "A ocurrido un error, intentalo más tarde.",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
          }
          
          this.loading = false;
          
        })
        .catch((error) => {
          console.error(error);
          this.$swal({
            icon: "error",
            text: "No se pudo procesar, verifique datos ingresados",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
          this.loading = false;
        }) ;
    },
    limpiar() {
      this.archivo = null;
      this.idPerfil = null;
      this.arrayDatosGeneralesExcel = {
        nombreArchivo: null,
        nombrePestana: null,
        cantidadRegistros: null,
      };
      this.arrayAgentesPromotores = [];
      this.archivo = null;
      this.archivo = null;
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.idEmpleado = this.$localStorageService.getIdEmpleado();
    this.idUsuario = this.$localStorageService.getIdUsuario();
  },
  computed: {},
  watch: {
    archivo: function () {
      if (this.archivo != null) {
        this.arrayDatosGeneralesExcel.nombreArchivo = this.archivo.name;
      }
    },
  },
};
</script>
